import { render, staticRenderFns } from "./abnormal.vue?vue&type=template&id=891dcfbe&scoped=true"
import script from "./abnormal.vue?vue&type=script&lang=js"
export * from "./abnormal.vue?vue&type=script&lang=js"
import style0 from "./abnormal.vue?vue&type=style&index=0&id=891dcfbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891dcfbe",
  null
  
)

export default component.exports